<template>
  <div>
    <ProviderMapHeaderEmbed class="opacity-map" :scale-to="55" :center-to="[10,10]" :countries="countries_id" />
    <RegionProfileCard :region="region" :list-countries="countries_id"/>
    <AppFooterEmbed />
  </div>
</template>

<style>
  .opacity-map {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    opacity: 0.5;
  }
</style>

<script>
  import AppFooterEmbed from '@/components/AppFooterEmbed.vue'
  import ProviderMapHeaderEmbed from '@/components/ProviderMapHeaderEmbed.vue'
  import RegionProfileCard from '@/components/RegionProfileCard'
  import region from '@/mixins/region'

  export default {
    name: 'RegionEmbed',
    components: {
      AppFooterEmbed,
      RegionProfileCard,
      ProviderMapHeaderEmbed
    },
    mixins: [region],
    data(){
      return {
        enableFooter: true
      }
    },
    mounted() {
      this.findRegion(this.$route.params.region_id)
    }
  }
</script>
